/**
 * Location Users - Location-level permissions management
 */

/** Location role types (location-specific, separate from account roles) */
export type LocationRole = 'admin' | 'manager' | 'viewer'

/** Location role display labels */
export const LOCATION_ROLE_LABELS: Record<LocationRole, string> = {
  admin: 'Admin',
  manager: 'Manager',
  viewer: 'Viewer',
}

/** Location role descriptions */
export const LOCATION_ROLE_DESCRIPTIONS: Record<LocationRole, string> = {
  admin: 'Full control of location settings and permissions',
  manager: 'Manage aircraft placement and operations',
  viewer: 'View-only access to location',
}

/** All location roles for select dropdowns */
export const LOCATION_ROLES: LocationRole[] = ['admin', 'manager', 'viewer']

/** Database row type for location_users table */
export interface LocationUserRow {
  id: string
  location_id: string
  user_id: string
  location_role: LocationRole
  created_at: string
  created_by: string | null
  updated_at: string | null
  updated_by: string | null
  deleted_at: string | null
  deleted_by: string | null
}

/** Insert type for creating new location user assignments */
export interface LocationUserInsert {
  location_id: string
  user_id: string
  location_role?: LocationRole
}

/** Update type for modifying location user assignments */
export interface LocationUserUpdate {
  location_role?: LocationRole
}

/** Location user with joined user details */
export interface LocationUserWithDetails extends LocationUserRow {
  user_email?: string
  user_display_name?: string | null
}

/** Form data for assigning a user to a location */
export interface AssignLocationUserFormData {
  user_id: string
  location_role: LocationRole
}

/** Form data for updating a location user's role */
export interface UpdateLocationUserRoleFormData {
  location_role: LocationRole
}

/** Table row type (subset for list display) */
export type LocationUserTableRow = Pick<
  LocationUserWithDetails,
  | 'id'
  | 'user_id'
  | 'location_role'
  | 'user_email'
  | 'user_display_name'
  | 'created_at'
>
